module.exports = __webpack_public_path__ + "img/286.6efa1267.svg";